<template>
  <div class="shortlist-edit-header">
    <div class="shortlist-names">
      <input
        type="text"
        placeholder="Shortlist name..."
        v-model="editingNameInternal"
      />
      <input
        type="text"
        placeholder="Internal shortlist name..."
        v-model="editingName"
      />
    </div>

    <span class="shortlist-delete" @click="deleteShortlist">
      <span class="material-icons">delete</span>
    </span>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "SharedShortlistsHeader",
  data() {
    return {};
  },
  computed: {
    ...mapState({
      loading: (state) => state.sharedShortlists.loading,
    }),
    editingName: {
      get() {
        return this.$store.state.sharedShortlists.editingName;
      },
      set(value) {
        this.$store.commit("sharedShortlists/setEditingName", value);
      },
    },
    editingNameInternal: {
      get() {
        return this.$store.state.sharedShortlists.editingNameInternal;
      },
      set(value) {
        this.$store.commit("sharedShortlists/setEditingNameInternal", value);
      },
    },
  },
  components: {},
  methods: {
    deleteShortlist: function () {
      if (this.loading) {
        return;
      }
      let confirm = window.confirm(
        "Permanently delete shortlist?\nThis can not be undone."
      );
      if (confirm) {
        this.$store.commit("setLoading", true);

        this.$store.dispatch("sharedShortlists/deleteShortlist").then(() => {
          this.$store.commit("setLoading", false);
        });
      }
    },
  },
};
</script>
